require('normalize.css/normalize.css')
require('../css/main.css')

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOMContentLoaded', 'page-error')
})
